export var IPHONE_X = 'iphonex-frame';
